const UserEvent = {
  fetchUserRooms: 'user/fetch-user-rooms',
  fetchUserRoomById: 'user/fetch-user-room-by-id',
  fetchUserHotels: 'user/fetch-user-hotels'
}

export default UserEvent
